import React from 'react';
import ItemizationSimulation from './ItemizationSimulation';
import GameDataLog from './GameDataLog';
import { Hero } from '../types/types';

interface Props {
  radiantHeroes: Hero[];
  direHeroes: Hero[];
  matchId: string;
  sessionId: string;
}

const EnhancedItemizationSimulation: React.FC<Props> = (props) => {
  const { matchId } = props;

  return (
    <>
      <ItemizationSimulation {...props} />

      {/* Add the GameDataLog component with proper styling */}
      <div className="bottom-container" style={{ marginTop: '20px' }}>
        <div style={{ height: '400px' }}>
          <GameDataLog matchId={matchId} height={350} />
        </div>
      </div>
    </>
  );
};

export default EnhancedItemizationSimulation; 